import React, { useEffect, useState } from "react";
import { getStaticData } from "../pureFunctions";
/* 
const initialData = {
   145: { preis: 5280000, anzahl: 12 },
   43: { preis: 4913785, anzahl: 9 },
   125: { preis: 4632000, anzahl: 14 },
   57: { preis: 4352250, anzahl: 7 },
   139: { preis: 4283000, anzahl: 11 },
   131: { preis: 3712000, anzahl: 18 },
   93: { preis: 3619400, anzahl: 6 },
   233: { preis: 3290000, anzahl: 10 },
   259: { preis: 2614500, anzahl: 8 },
   207: { preis: 2488000, anzahl: 15 },
   89: { preis: 2031000, anzahl: 5 },
   229: { preis: 1664500, anzahl: 13 },
   231: { preis: 860000, anzahl: 4 },
   147: { preis: 188500, anzahl: 3 },
   53: { preis: 0, anzahl: 2 },
   23: { preis: 0, anzahl: 1 },
   137: { preis: 0, anzahl: 6 },
   115: { preis: 0, anzahl: 0 },
   59: { preis: 0, anzahl: 2 },
   77: { preis: 0, anzahl: 4 },
   83: { preis: 0, anzahl: 1 },
   143: { preis: 0, anzahl: 3 },
   65: { preis: 0, anzahl: 0 },
   41: { preis: 0, anzahl: 5 },
   33: { preis: 0, anzahl: 7 },
   37: { preis: 0, anzahl: 1 },
   126: { preis: 0, anzahl: 2 },
   47: { preis: 0, anzahl: 0 },
   187: { preis: 0, anzahl: 8 },
}; */

const initialData = {
  145: { preis: 5280000, anzahl: 14 },
  43: { preis: 4913785, anzahl: 15 },
  125: { preis: 4632000, anzahl: 9 },
  57: { preis: 4352250, anzahl: 13 },
  139: { preis: 4283000, anzahl: 11 },
  131: { preis: 3712000, anzahl: 10 },
  93: { preis: 3619400, anzahl: 11 },
  233: { preis: 3290000, anzahl: 15 },
  259: { preis: 2614500, anzahl: 0 },
  207: { preis: 2488000, anzahl: 10 },
  89: { preis: 2031000, anzahl: 7 },
  229: { preis: 1664500, anzahl: 0 },
  231: { preis: 860000, anzahl: 0 },
  147: { preis: 188500, anzahl: 0 },
};

const formatPreis = (n) => n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";

function Leaderboard({ userObjects, data, titel, sortKey, format }) {
   const eintraege = Object.entries(data)
      .map(([id, werte]) => ({ id, name: userObjects?.[id]?.Name ?? "Sonstige",kuerzel: userObjects?.[id]?.Kuerzel ?? "-", ...werte }))
      .sort((a, b) => b[sortKey] - a[sortKey]);

   return (
      <div>
         <h1 className="display-5 fw-bold mb-4">{titel}</h1>
         <ul className="list-group list-group-flush">
            {eintraege.map((e, i) => {
               const rang = i + 1;
               const initial = (e.kuerzel || "?")
               return (
                  <li key={e.id} className="list-group-item d-flex align-items-center gap-3 py-3 px-0">
                     <div className="position-relative flex-shrink-0">
                        <div
                           className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center fw-bold"
                           style={{ width: "56px", height: "56px", fontSize: "1.25rem" }}
                        >
                           {initial}
                        </div>
                        <span
                           className={`position-absolute top-0 start-0 translate-middle rounded-circle d-flex align-items-center justify-content-center fw-bold shadow-sm ${
                              rang === 1 ? "bg-warning text-dark" : "bg-white text-dark border"
                           }`}
                           style={{ width: "28px", height: "28px", fontSize: "0.85rem" }}
                        >
                           {rang}
                        </span>
                     </div>

                     <div className="flex-grow-1 text-truncate">
                        <div className="fw-bold fs-5 lh-sm">{e.name}</div>
                        <div className="text-muted small">BAUR Immobilien GmbH</div>
                     </div>

                     <div className="fw-bold fs-5 text-nowrap">{format(e[sortKey])}</div>
                  </li>
               );
            })}
         </ul>
      </div>
   );
}

export default function Leaderboards() {
   const [data, setData] = useState(initialData);
   const [userObjects, setUserObjects] = useState();

   async function getData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData()
      setUserObjects(cleanUserData.userObject);
   }

   useEffect(() => {
      getData();
   }, []);

   return (
      <div className="container py-4">
         <div className="row g-5">
            <div className="col-12 col-lg-6">
               <Leaderboard titel="Summe" sortKey="preis" data={data} userObjects={userObjects} format={formatPreis} />
            </div>
            <div className="col-12 col-lg-6">
               <Leaderboard titel="Anzahl" sortKey="anzahl" data={data} userObjects={userObjects} format={(n) => n} />
            </div>
         </div>
      </div>
   );
}
